/**
 * Centralized React Query key factory for the Inspection Series listing.
 *
 * Key structure (contract §7):
 *   ['series-listing', scope, normalizedFilters, sort, pageNumber, pageSize]
 *
 * - Multi-select array values are order-normalized (sorted) before hashing.
 * - Scope type/id and sort field/direction are in fixed order.
 * - search is part of the key when present (IP-15819).
 * - The feature namespace 'series-listing' distinguishes keys from Inspections
 *   keys in the same QueryClient (though separate QueryClientProviders are used).
 */
import { buildQueryKeySegment, normalizeMultiSelect } from '@hooks/listings';
export const SERIES_QUERY_NAMESPACE = 'series-listing';
/** Normalized filter snapshot used as part of the query key. */
function normalizeFilters(filters) {
    return {
        building: normalizeMultiSelect(filters.building),
        account: normalizeMultiSelect(filters.account),
        territory: normalizeMultiSelect(filters.territory),
        expirationDate: filters.expirationDate,
        status: filters.status,
        autoExtend: filters.autoExtend,
        expiredSeries: filters.expiredSeries
    };
}
/**
 * Builds the full React Query key for a series listing state.
 *
 */
export function seriesQueryKey(state) {
    var _a;
    const segment = buildQueryKeySegment(state.scope, normalizeFilters(state.filters), state.sort, state.page.number, state.page.size);
    return [SERIES_QUERY_NAMESPACE, (_a = state.search) !== null && _a !== void 0 ? _a : '', ...segment];
}
export const seriesKeys = {
    /** Base key — invalidates all series listing queries. */
    all: [SERIES_QUERY_NAMESPACE],
    /** Key scoped to a specific normalized state (used by useQuery). */
    listing: (state) => seriesQueryKey(state)
};
